import React, { useState, useEffect } from "react";
import { decrypt } from "../../utils/encodingdecoding";
import { Link } from "react-router-dom";
import { arjunMerchantId, starblazeMerchantId } from "../../utils";

const Header = (props) => {
    const [name, setName] = useState();

    useEffect(() => {
        if (localStorage.getItem("name")) {
            let tempName = decrypt(localStorage.getItem("name"));
            tempName = `${tempName[0].toUpperCase()}${tempName.slice(1)}`;
            setName(tempName);
        }
    }, []);
    const temp = localStorage.getItem("email");
    const Id = localStorage.getItem("Id")


    const names = props.name || "";
    return (
        <div className="dashboard__headerSection">
            {!name && !temp && (
                <figure>
                    <img src={""} alt="logo" width="180" loading="lazy" style={{ marginTop: "10px", marginLeft: "10px", paddingLeft: "15px" }} />
                </figure>
            )}

            <div className="dashboard__heading">
                <h3>{props.name}</h3>
            </div>
            {name && (
                <Link to={decrypt(Id) === starblazeMerchantId || arjunMerchantId ? "" : "/settings"} className="dashboard__username">
                    <h5>
                        Welcome <span>{name}</span>
                    </h5>
                </Link>
            )}

        </div>
    );
};

export default Header;
